// extracted by mini-css-extract-plugin
module.exports = {"animatedEllipsis":"style-module__animatedEllipsis___2h6pi","ellipsisAnimation":"style-module__ellipsisAnimation___3S3Lj","textDivider":"style-module__textDivider___2wdI6"};